<template>
  <IconLucideSignpostBig />
</template>
